import { render } from "./openSource.vue?vue&type=template&id=61d92db1"
import script from "./openSource.vue?vue&type=script&lang=js"
export * from "./openSource.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__